import { render, staticRenderFns } from "./NoteListComponent.vue?vue&type=template&id=10436032&scoped=true&"
import script from "./NoteListComponent.vue?vue&type=script&lang=ts&"
export * from "./NoteListComponent.vue?vue&type=script&lang=ts&"
import style0 from "./NoteListComponent.vue?vue&type=style&index=0&id=10436032&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "10436032",
  null
  
)

export default component.exports